import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Portfolio from "@/components/site/Portfolio";
import Philosophy from "@/components/site/Philosophy";
import WhyDuneworth from "@/components/site/WhyDuneworth";
import ContactCTA from "@/components/site/ContactCTA";
import Footer from "@/components/site/Footer";
import MediaPage from "@/pages/Media";
import { useHashScroll } from "@/hooks/useHashScroll";

const Landing = () => {
  useHashScroll();
  return (
    <div data-testid="duneworth-landing" className="bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <About />
        <Portfolio />
        <Philosophy />
        <WhyDuneworth />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/media" element={<MediaPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Outfit, sans-serif",
            letterSpacing: "0.02em",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
